import { Box, CircularProgress, Stack, Typography } from '@mui/material';

interface LoadingSpinnerProps {
    message?: string;
}

const Loader = ({ message }: LoadingSpinnerProps) => (
    <Stack alignItems="center" gap={2}>
        <CircularProgress />
        <Typography variant="body2">{message}</Typography>
    </Stack>
);

export function LoadingSpinner({ message = 'Loading...' }: LoadingSpinnerProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}
        >
            <Loader message={message} />
        </Box>
    );
}
